import SwapOffer from './Offer.vue'

export default SwapOffer
